// extracted by mini-css-extract-plugin
module.exports = {"aside":"_-ui-admin-lib-Aside-index-module__aside--2tOf_","toggle":"_-ui-admin-lib-Aside-index-module__toggle--22sfU"};